/* eslint-disable @typescript-eslint/unbound-method */
import { Logger } from './Logger';
import { LoggerDecorator } from './LoggerDecorator';

export const LOG_LEVELS = {
  LOG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  NONE: 4,
};

function noop(): void {
  // noop
}

export function decorateLoggerLevel(level = 0): LoggerDecorator {
  return (logger: Logger): Logger => {
    const log = level <= LOG_LEVELS.LOG ? logger.log : noop;
    const info = level <= LOG_LEVELS.INFO ? logger.info : noop;
    const warn = level <= LOG_LEVELS.WARN ? logger.warn : noop;
    const error = level <= LOG_LEVELS.ERROR ? logger.error : noop;

    return { log, info, warn, error };
  };
}
